import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      marginTop: theme.spacing(2),
    },
    button: {
      width: "63px",
      height: "29px",
      padding: "5px 12px 8px 12px",
      borderRadius: "4px",
      borderStyle: "solid",
      color: theme.palette.common.white,
      fontWeight: "bold",
      fontSize: "12px",
      lineHeight: "16px",
      textTransform: "none",
      marginLeft: 0,
    },
    deleteButton: {
      marginLeft: "auto",
    },
    cancelButton: {
      marginLeft: theme.spacing(5),
    },
  })
);
